import { render, staticRenderFns } from "./project_details2.vue?vue&type=template&id=924de0c8&scoped=true&"
import script from "./project_details2.vue?vue&type=script&lang=js&"
export * from "./project_details2.vue?vue&type=script&lang=js&"
import style0 from "./project_details2.vue?vue&type=style&index=0&id=924de0c8&lang=scss&scoped=true&"
import style1 from "./project_details2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924de0c8",
  null
  
)

export default component.exports